import { gql } from "@apollo/client";


export const DELETE_INVITE_LINK = gql`
    mutation DeleteInviteLink($id: String!) {
        deleteInviteLink(id: $id) {
            id
            createdAt
            updatedAt
            code
            email
            role
            companyId
            isUsed
            usedById
        }
    }
`;